// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__vvwJg","text":"Loader_text__Az4XK"};